import React, { useEffect, useState } from 'react';
import GrindExplainer from './GrindExplainer';
import GoalForm from './GoalForm';
import GoalList from './GoalList';
import { saveGoal, getGoals, deleteGoal } from '../firebaseUtils';

function GoalsPage({ user }) {
  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchGoals();
  }, []);

  const fetchGoals = async () => {
    setLoading(true);
    const data = await getGoals();
    setGoals(data);
    setLoading(false);
  };

  const handleAddGoal = async (newGoal) => {
    await saveGoal(newGoal);
    await fetchGoals();
    setShowForm(false);
  };

  const handleDeleteGoal = async (goalToDelete) => {
    await deleteGoal(goalToDelete.id);
    await fetchGoals();
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#111',
      color: '#fff',
      paddingTop: '80px',
      paddingBottom: '60px',
    }}>
      <div style={{
        maxWidth: '700px',
        margin: '0 auto',
        padding: '0 16px',
      }}>
        <h1 style={{
          fontFamily: 'Bangers, sans-serif',
          fontSize: 'clamp(1.8rem, 6vw, 3rem)',
          letterSpacing: '2px',
          textAlign: 'center',
          marginBottom: '6px',
          color: '#fff',
        }}>
          🎯 Create YOUR Journey
        </h1>
        <p style={{
          textAlign: 'center',
          color: '#aaa',
          fontSize: '1rem',
          marginBottom: '30px',
        }}>
          Become the best wrestler you can be
        </p>

        <GrindExplainer />

        <div style={{ textAlign: 'center', margin: '30px 0' }}>
          <button
            onClick={() => setShowForm(!showForm)}
            style={{
              backgroundColor: '#FFD700',
              color: '#000',
              border: 'none',
              borderRadius: '8px',
              padding: '14px 32px',
              fontSize: '1.1rem',
              fontFamily: 'Bangers, sans-serif',
              letterSpacing: '2px',
              cursor: 'pointer',
            }}
          >
            {showForm ? '✖ Cancel' : '➕ Create New GRIND Goal'}
          </button>
        </div>

        {showForm && (
          <div style={{
            backgroundColor: '#1a1a1a',
            borderRadius: '12px',
            padding: '24px',
            marginBottom: '30px',
          }}>
            <GoalForm onSubmit={handleAddGoal} />
          </div>
        )}

        {loading ? (
          <p style={{ textAlign: 'center', color: '#888' }}>Loading your goals...</p>
        ) : (
          <GoalList
            goals={goals}
            onDeleteGoal={handleDeleteGoal}
          />
        )}
      </div>
    </div>
  );
}

export default GoalsPage;